// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";
// @ts-ignore
import { ElementStruct } from "./element_struct";

export class UpdateElementStructReducer extends Reducer
{
	public static reducerName: string = "UpdateElementStruct";
	public static call(_elementId: number, _elementStruct: ElementStruct) {
		this.getReducer().call(_elementId, _elementStruct);
	}

	public call(_elementId: number, _elementStruct: ElementStruct) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _elementStructType = ElementStruct.getAlgebraicType();
		serializer.write(_elementStructType, _elementStruct);
		this.client.call("UpdateElementStruct", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let elementStructType = ElementStruct.getAlgebraicType();
		let elementStructValue = AlgebraicValue.deserialize(elementStructType, adapter.next())
		let elementStruct = ElementStruct.fromValue(elementStructValue);
		return [elementId, elementStruct];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _elementStruct: ElementStruct) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _elementStruct: ElementStruct) => void)
	{
		this.client.on("reducer:UpdateElementStruct", callback);
	}
}


export default UpdateElementStructReducer
